// extracted by mini-css-extract-plugin
export var closed = "_at-1";
export var resizer = "_at-0";